import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=79358a74&"
import script from "./Goals.vue?vue&type=script&lang=js&"
export * from "./Goals.vue?vue&type=script&lang=js&"
import style0 from "./Goals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports